export default "__VITE_ASSET__BQbT5vHP__"